import type { Button } from '@/components/Button/Button'

import css from './Modal.module.css'
import type { ReactElement } from 'react'

type ModalFooterProps = {
    primaryButton?: ReactElement<typeof Button>
    secondaryButton?: ReactElement<typeof Button>
}

function ModalFooter({ primaryButton, secondaryButton }: ModalFooterProps) {
    return (
        <div className={css.modalFooter}>
            <>
                {secondaryButton ? secondaryButton : null}
                {primaryButton ? primaryButton : null}
            </>
        </div>
    )
}

export { ModalFooter }
